import { useApiBackendInfo } from '@/hooks/query/use-api-backend-info';
import { useQuery } from '@tanstack/react-query';
import queryKeys from '@/constants/query-keys';
import { useLicSettings } from '@/domains/config/hooks/use-lic-settings';

import { wcPromotionSpinService } from '@/domains/wc-promotion/services/wc-promotion-spin.service';

export const useWcPromotionSpinDailyInfo = () => {
	const { enableWcPromotionLuckySpin } = useLicSettings();
	const apiBackendInfo = useApiBackendInfo();

	const { data, isLoading, isError, error, refetch } = useQuery({
		queryKey: [queryKeys.WC_PROMOTION_SPIN_DAILY_INFO, apiBackendInfo.url, apiBackendInfo.token],
		queryFn: () => wcPromotionSpinService.fetchWcPromotionSpinDailyInfo(apiBackendInfo),
		staleTime: 60 * 1000,
		cacheTime: 2 * 60 * 1000,
		enabled: enableWcPromotionLuckySpin && apiBackendInfo.isReady,
		refetchOnMount: 'always'
	});

	return {
		data: data?.Data,
		isLoading,
		isError,
		error,
		refetch
	};
};
